import { useState } from 'react';

export default function useGlobalState() {
  const [datasetFilter, setDatasetFilter] = useState<object>({}); // 数据集筛选条件：卡片列表页用
  const [seriesDataInViewLayer, setSeriesDataInViewLayer] = useState<object>({}); // 一个序列记录：'查看层'页用
  const [currentTenantId, setCurrentTenantId] = useState<number | null>(null); // 当前租户 ID
  return {
    datasetFilter,
    setDatasetFilter,
    seriesDataInViewLayer,
    setSeriesDataInViewLayer,
    currentTenantId,
    setCurrentTenantId,
  };
}